import { AxiosResponse } from 'axios';
import { DEVICE_INFO_API_URL } from '../../../config';
import deviceInfoAxios from '../../../utils/axios/deviceInfo.axios';

type SearchParams = {
  pageNumber: number;
  pageSize: number;
  // optional filters
  category?: string;
  subCategory?: string;
  allCategories?: boolean;
  allSubcategories?: boolean;
  unassignedOnly?: boolean;
  tripId?: string;
  userId?: string;
  trainManagerId?: string;
  crewMemberId?: string;
  startDate?: string;
  endDate?: string;
};

const buildQS = (params: Record<string, any>) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === '') return;
    qs.set(k, String(v));
  });
  return qs.toString();
};

const tryToFetchTopicTaxonomy = (): Promise<AxiosResponse<any>> => {
  const url = `${DEVICE_INFO_API_URL}/rebecca-ai-agent/topic-taxonomy`;
  return deviceInfoAxios.get(url);
};

const tryToSearchFeedbackTopics = (args: SearchParams): Promise<AxiosResponse<any>> => {
  const { pageNumber, pageSize, ...filters } = args;
  const qs = buildQS({ page: pageNumber, size: pageSize, ...filters });
  const url = `${DEVICE_INFO_API_URL}/rebecca-ai-agent/feedbacks/search?${qs}`;
  return deviceInfoAxios.get(url);
};

const tryToGetFeedbackTopicStats = (filters?: Omit<SearchParams, 'pageNumber' | 'pageSize'>): Promise<AxiosResponse<any>> => {
  const qs = buildQS(filters || {});
  const url = `${DEVICE_INFO_API_URL}/rebecca-ai-agent/feedbacks/assignment-stats${qs ? `?${qs}` : ''}`;
  return deviceInfoAxios.get(url);
};

const tryToFetchFeedbackExecByCategory = (data?: Record<string, any>): Promise<AxiosResponse<any>> => {
  const url = `${DEVICE_INFO_API_URL}/rebecca-ai-agent/feedback-executive/by-category`;
  return deviceInfoAxios.put(url, data || {});
};

export const FeedbackTopicsService = {
  tryToFetchTopicTaxonomy,
  tryToSearchFeedbackTopics,
  tryToGetFeedbackTopicStats,
  tryToFetchFeedbackExecByCategory,
};
